export default {
  icon_text: 'Chiuso',
  buttons: {
    ok: 'Ok',
  },
};
